module.exports = __webpack_public_path__ + "static/media/wizualizacja-106.1068576e.png";